import { Event } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const EVENTS_DATA: Event[] = [
  {
    id: 'salon-livre-2026',
    title: 'Salon du Livre de Gréasque',
    description: 'Rencontrez vos auteurs préférés lors de notre salon du livre annuel. Dédicaces, conférences et animations pour toute la famille. Une journée dédiée à la littérature et à la culture provençale.',
    date: '2026-05-15',
    time: '10h00 - 18h00',
    location: 'Centre Culturel Municipal',
    category: 'Littérature',
    image: IMAGES.CULTURE_1,
  },
  {
    id: 'atelier-yoga-printemps',
    title: 'Ateliers Yoga en plein air',
    description: 'Séances de yoga pour tous niveaux dans le parc municipal. Profitez du cadre naturel de Gréasque pour vous détendre et vous ressourcer. Tapis fournis, inscription obligatoire.',
    date: '2026-04-20',
    time: '9h00 - 10h30',
    location: 'Parc Municipal',
    category: 'Atelier',
    image: IMAGES.EVENEMENT_7,
  },
  {
    id: 'escalade-jeunes',
    title: 'Activité Escalade pour les jeunes',
    description: 'Initiation à l\'escalade pour les 8-16 ans. Encadrement professionnel, matériel fourni. Une activité sportive pour développer confiance en soi et esprit d\'équipe.',
    date: '2026-04-25',
    time: '14h00 - 17h00',
    location: 'Gymnase Municipal',
    category: 'Sport',
    image: IMAGES.EVENEMENT_5,
  },
  {
    id: 'braderie-secours-populaire',
    title: 'Braderie du Secours Populaire',
    description: 'Grande braderie solidaire organisée par le Secours Populaire. Vêtements, livres, jouets à petits prix. Les bénéfices seront reversés aux actions de solidarité locale.',
    date: '2026-05-10',
    time: '8h00 - 17h00',
    location: 'Place de la Mairie',
    category: 'Solidarité',
    image: IMAGES.EVENEMENT_10,
  },
  {
    id: 'fete-musique-2026',
    title: 'Fête de la Musique',
    description: 'Concerts gratuits dans toute la ville. Groupes locaux et artistes régionaux se produiront sur plusieurs scènes. Ambiance festive garantie pour célébrer la musique sous toutes ses formes.',
    date: '2026-06-21',
    time: '18h00 - 23h00',
    location: 'Centre-ville',
    category: 'Spectacle',
    image: IMAGES.EVENEMENT_7,
  },
  {
    id: 'ceremonie-8-mai',
    title: 'Cérémonie du 8 Mai',
    description: 'Commémoration de la victoire de 1945. Dépôt de gerbe au monument aux morts, discours officiels et moment de recueillement en présence des autorités municipales et des associations d\'anciens combattants.',
    date: '2026-05-08',
    time: '11h00',
    location: 'Monument aux Morts',
    category: 'Cérémonies',
    image: IMAGES.EVENEMENT_5,
  },
];